const SVG = ({ fill = 'currentColor', width = '36', height = '40', viewBox = '0 0 36 40' }) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M29.614 27.34l-5.746-1.45-.332-1.341c3.965-.675 6.005-1.875 6.095-1.928a.76.76 0 00.363-.603.773.773 0 00-.287-.648C29.68 21.349 27 19.112 27 11.364c0-6.535-1.514-9.849-4.5-9.849h-.442C20.98.464 20.172 0 18 0c-2.819 0-9 2.862-9 11.364 0 7.748-2.68 9.985-2.7 10a.758.758 0 00.063 1.255c.09.054 2.11 1.26 6.099 1.933l-.332 1.337-5.746 1.452C2.625 28.29 0 35.324 0 39.242c0 .419.336.758.75.758h34.5c.414 0 .75-.342.75-.76 0-3.916-2.625-10.95-6.386-11.9z" />
  </svg>
)

export default SVG
